import {atomWithStorage} from 'jotai/utils';
import {KodataCategoryGroup} from '../@types';

export const rankingBoardCategoryAtom = atomWithStorage<
  KodataCategoryGroup | undefined
>('myfcmap/ranking/category', undefined);
